import React from 'react';
import moment from 'moment';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import * as actions from '../../_redux/invoiceOrdersActions';
import can from '../../../_common/components/Permissions/can';

export function CreatedColumnFormatter(cellContent, intl, dispatch) {
  const wasCreatedTooltip = intl.formatMessage({
    id: 'invoice-orders-button-tooltip-wasCreated',
    defaultMessage: 'Update that an invoice was created manually for this order',
  });
  const buttonClassName = `btn btn-icon btn-light btn-sm custom-action-button
                           ${(can('full', 'invoiceOrders'))
    ? ``
    : `custom-disabled-button cursor-default`}`;

  return (
    <Button
      className={buttonClassName}
      onClick={() => {
        dispatch(actions.setInvoiceOrderSentManually(
            cellContent?._id,
            cellContent?.totalAmount,
            cellContent?.createdAt ? moment(cellContent.createdAt).format('DD-MM-YYYY') : '',
            cellContent?.agentID
          )
        );
      }}
      title={wasCreatedTooltip}
      disabled={!(can('full', 'invoiceOrders'))}
    >
      <img
        src={toAbsoluteUrl('/media/svg/Check_brandColor.svg')}
        alt="check"
      />
    </Button>
  );
}
